import { render } from "./PdfDB.vue?vue&type=template&id=206af2cd&scoped=true"
import script from "./PdfDB.vue?vue&type=script&lang=js"
export * from "./PdfDB.vue?vue&type=script&lang=js"

import "./PdfDB.vue?vue&type=style&index=0&id=206af2cd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206af2cd"]])

export default __exports__